import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import indexPost from 'actions/post/index';
import Modal from 'components/Modal/Modal';
import './ArticleModal.module.scss';

// Import types
import QuoteBlock from 'screens/Article/components/QouteBlock/QuoteBlock';
import HighlightBlock from 'screens/Article/components/HighlightBlock/HighlightBlock';
import ImageSingle from 'screens/Article/components/ImageSingle/ImageSingle';
import ImageDouble from 'screens/Article/components/ImageDouble/ImageDouble';
import ButtonRow from 'screens/Article/components/ButtonRow/ButtonRow';
import Line from 'screens/Article/components/Line/Line';
import Title from 'screens/Article/components/Title/Title';
import Text from 'screens/Article/components/Text/Text';
import TitleAndImages from '../Layouts/TitleAndImages/TitleAndImages';
import TitleAndDescription from '../Layouts/TitleAndDescription/TitleAndDescription';
import Quote from '../Layouts/Quote/Quote';
import TitleAndImage from '../Layouts/TitleAndImage/TitleAndImage';

type Props = {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalIsOpen: boolean;
  item: any;
};

export default function ArticleModal({
  setModalIsOpen,
  modalIsOpen,
  item,
}: Props) {
  const { id } = useParams() as {
    id: string;
    url: string;
  };
  const [articleId, setArticleId] = useState<string>();
  const dispatch = useDispatch();

  // Add stuff to store
  useEffect(() => {
    dispatch(indexPost());
    setArticleId(id);
  }, [modalIsOpen]);

  const article = useSelector((state) => state.post.entities.byId[articleId]);
  const articleContent = article?.content;

  console.log(article, 'articledata');

  return (
    <Modal
      // shadeColor={`${article?.background}`}
      noPadding
      setModalIsOpen={setModalIsOpen}
    >
      <div
        style={{ background: `${article?.background}` }}
        styleName="ArticleModal"
      >
        <div styleName="top">
          {(() => {
            const content = item?.block_layout?.[0];
            switch (content?.layout) {
              case 'title_and_image':
                return (
                  <TitleAndImage
                    inPopup
                    lowTile={false}
                    attributes={content?.attributes}
                  />
                );
              case 'title_and_images':
                return (
                  <TitleAndImages inPopup attributes={content?.attributes} />
                );
              case 'title_and_description':
                return (
                  <TitleAndDescription
                    inPopup
                    attributes={content?.attributes}
                  />
                );
              case 'title':
                return <Title attributes={content?.attributes} />;
              case 'quote':
                return <Quote attributes={content?.attributes} />;
              default:
                return <p>default</p>;
            }
          })()}
          <p styleName="source">{item?.source}</p>
        </div>
        <div styleName="inner">
          {articleContent?.map((item, i) => {
            console.log(item.layout);
            if (item.layout === 'title') {
              return <Title item={item} key={i} />;
            }
            if (item.layout === 'text') {
              return <Text item={item} key={i} />;
            }
            if (item.layout === 'quote_block') {
              return <QuoteBlock item={item} key={i} />;
            }
            if (item.layout === 'highlight_block') {
              return <HighlightBlock item={item} key={i} />;
            }
            if (item.layout === 'image_single') {
              return <ImageSingle item={item} key={i} />;
            }
            if (item.layout === 'image_double') {
              return <ImageDouble item={item} key={i} />;
            }
            if (item.layout === 'button_row') {
              return <ButtonRow item={item} key={i} />;
            }
            if (item.layout === 'line') {
              return <Line key={i} />;
            }
          })}
        </div>
      </div>
    </Modal>
  );
}
